import templateUrl from "./payroll-manual-submission-modal.component.html";
import "./payroll-manual-submission-modal.component.less";

export const PayrollManualSubmissionModal = {
    windowClass: 'xx-dialog pagespinner',
    component: "apexPayrollManualSubmissionModal",
    size: 'lg',
    backdrop: 'static',
}

export const PayrollManualSubmissionModalComponent = {
    templateUrl,
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    controller: class {
        /**
         * Construct the container component.
         * @param {import("../payroll-manual-submission.service").PayrollManualSubmissionService} payrollManualSubmissionService
         * @param {any} utilityService The UI utility service.
         */
        constructor(payrollManualSubmissionService, utilityService) {
            'ngInject'
            this.payrollManualSubmissionService = payrollManualSubmissionService;
            this.utilityService = utilityService;
            this.filteredPayrollEntries = {};
            this.state = null;
        }

        $onInit() {
            const initializeState = this.payrollManualSubmissionService.initializeSubmissionForm({
                manualRequest: this.resolve.manualRequest,
                icdCorporations: this.resolve.icdCorporations,
                payrolls: this.resolve.payrolls,
                payrollID: this.resolve.payrollID,
                payPeriods: this.resolve.payPeriods,
                schedule: this.resolve.schedule
            })
                .then(state => {
                    this.state = state;
                    this.payroll = this.resolve.payroll;
                    this.payPeriod = this.resolve.payPeriod;
                    this.departmentName = this.resolve.payPeriod.Employee.departmentName;
                    this.IsRegistrationComplete = this.resolve.payPeriod.Employee.IsRegistrationComplete;
                });
            this.utilityService.showLoadingUntilResolved(
                initializeState
            );
        }

        onChangeExtraShowHours({ extraShowHours }) {
            this.payrollManualSubmissionService.changeManualRequest(this.state, {
                ...this.state.manualRequest,
                ExtraShowHours: extraShowHours
            })
                .then(state => this.state = state);
        }

        onChangeExtraTimeEntries({ extraTimeEntries }) {
            this.payrollManualSubmissionService.changeExtraTimeEntries(this.state, extraTimeEntries)
                .then(state => this.state = state);
        }

        onChangeCheckDate({ checkDate }) {
            this.payrollManualSubmissionService.changeManualRequest(this.state, {
                ...this.state.manualRequest,
                CheckDate: checkDate
            })
                .then(state => this.state = state);
        }

        onSubmitRequest() {
            const saving = this.payrollManualSubmissionService.submitManualRequest(this.state)
                .then(state => this.state = state)
                .then(state => {
                    this.close({ $value: this.payroll.PayrollID })
                });
            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(saving, "Saving failed")
            );

        }

        onCancel() {
            this.dismiss({ $value: 'cancel' });
        }
    }
}
